<template>
    <div v-if="params.inputType == 'input' && !params.isShow">
        <!-- <el-input v-model="ruleForm[params.filed]" :type="params.typeValue" :placeholder="params.placeholder"
         :disabled="params.disabled" :show-password="params.isShowPassword" :rows="params.rows || 5" 
         :max="params.max" :min="params.min"
         clearable></el-input> -->
         <el-input v-model="ruleForm[params.filed]" :type="params.typeValue" :placeholder="'请输入'+$utils.labelByValue_global(params)"
         :disabled="params.disabled" :show-password="params.isShowPassword" :rows="params.rows || 5" 
         :max="params.max" :min="params.min"
         clearable></el-input>
    </div>
    <div v-else-if="params.inputType == 'button' && !params.isShow" class="btnUrlClass">
         <el-button :type="params.type || 'primary '" :loading="params.isLoading" :disabled="params.disabled"
          :size="params.size || 'small'" @click="()=>{params.btnClick ? params.btnClick(params) : ''} ">
            {{ params.btnValue }}
        </el-button>
        <div class="disFlex" v-if="params.value">
            <span class="marR10">{{ reverseName(params.value,"/")  }}</span>
            <span   class="close-wrap-f"  @click.stop = "params.closeFun(params)">
                <i class="el-icon-circle-close"></i>
            </span>
            <el-button class="marR10" type="primary" plain size="mini" @click.stop="downloadFile(params.value)">下载</el-button>
        </div>
    </div>
    <div v-else-if="params.inputType == 'button_noclose' && !params.isShow" class="btnUrlClass">
         <el-button :type="params.type || 'primary '" :loading="params.isLoading" :disabled="params.disabled"
          :size="params.size || 'small'" @click="()=>{params.btnClick ? params.btnClick(params) : ''} ">
            {{ params.btnValue }}
        </el-button>
        <div class="disFlex" v-if="params.value">
            <span class="marR10">{{ reverseName(params.value,"/")  }}</span>
            <!-- <span   class="close-wrap-f"  @click.stop = "params.closeFun(params)">
                <i class="el-icon-circle-close"></i>
            </span> -->
            <el-button class="marR10" type="primary" :disabled="false" plain size="mini" @click.stop="downloadFile(params.value)">下载</el-button>
        </div>
    </div>
    <div v-else-if="params.inputType == 'html' && !params.isShow">
        <el-input v-html="ruleForm[params.filed]" :type="params.typeValue" :placeholder="params.placeholder"
         :disabled="params.disabled" :show-password="params.isShowPassword" :rows="params.rows || 5" clearable></el-input>
    </div>
    <div v-else-if="params.inputType == 'editor' && !params.isShow">
        <EditorCon :params="params" ></EditorCon>
    </div>
    <div v-else-if="params.inputType == 'editorTitle' && !params.isShow">
        <EditorTitleCon :params="params" ></EditorTitleCon>
    </div>
    <div v-else-if="params.inputType == 'radio' && !params.isShow">
        <el-radio-group v-model="ruleForm[params.filed]" :disabled="params.disabled"   @change="(val)=>{params.change ? params.change(val) : ''}">
            <el-radio  v-for="(item,index) in params.options" :key="index" :label="item.value">{{ item.label }}</el-radio>
        </el-radio-group>
    </div>
    <div v-else-if="params.inputType == 'area' && !params.isShow">
        <v-distpicker :disabled="params.disabled" 
            :hide-area="params.hideArea"
           :province="params.province" :city="params.city" :area="params.region"
           @province= "(data)=>{params.getProvince ? params.getProvince(data) : ''}"
           @city="(data)=>{params.getCity ? params.getCity(data) : ''}"
            @area="(data)=>{params.getArea ? params.getArea(data) : ''}" 
           @selected="(data)=>{params.onSelectRegion ? params.onSelectRegion(data) : ''}"></v-distpicker>
    </div>
    <div v-else-if="params.inputType == 'select'">
        <!-- filterable=Boolean(params.filterable) -->
        <!-- <div>111</div> -->
        <!-- <select >
            <option  v-for="(item,index) in params.options" :value="item.value">{{ item.label }}</option>
        </select> -->
        
        <!-- <el-select v-model="ruleForm[params.filed]" :placeholder="params.placeholder" filterable -->
        <el-select v-model="ruleForm[params.filed]" :placeholder="'请选择'+$utils.labelByValue_global(params)" filterable
        :multiple="params.multiple"  :disabled="params.disabled" :collapse-tags="params.multiple"
        @change="(val)=>{params.change ? params.change(val) : ''}" clearable>
            <el-option
                v-for="item in params.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
            </el-option>
        </el-select>
    </div>
    <div v-else-if="params.inputType == 'selectNoTags'" class="selectNoTags">
        <el-select v-model="ruleForm[params.filed]" :placeholder="'请选择'+$utils.labelByValue_global(params)" filterable
        :multiple="params.multiple"  :disabled="params.disabled" 
        @change="(val)=>{params.change ? params.change(val) : ''}" clearable>
            <el-option
                v-for="item in params.options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
                :disabled="item.disabled">
            </el-option>
        </el-select>
    </div>
    <div v-else-if="params.inputType == 'date'">
        <el-date-picker
            v-model="ruleForm[params.filed]"
            :type="params.typeValue"
            :disabled="params.disabled"
            :format="params.format"
            :value-format = "params.format"
            :default-value="params.defaultValue"
            :placeholder="params.placeholder"
            :start-placeholder="params.startPlaceholder"
            :end-placeholder="params.endPlaceholder"
            unlink-panels
            @change="(val)=>{params.change ? params.change(val) : ''}"
            >
        </el-date-picker>
    </div>
    <div  v-else-if="params.inputType == 'upload'">
        <div v-if="params.typeValue == 'img'"  >
            <el-upload
            name="file"
            class="avatar-uploader"
            :action="this.$utils.uploadAction(params.fileParams).action"
            :show-file-list="false"
            :on-success="params.handleSuccess"
            :before-upload="params.beforeAvatarUpload"
            :on-change="params.onChange"
            :on-preview="params.handlePreview"
            :on-remove="params.handleRemove"
            :on-error="params.handleError"
            :before-remove="params.beforeRemove"
            :multiple="params.multiple"
            :on-exceed="params.handleExceed"
            :disabled="params.disabled"
            :limit="params.limit"
            :file-list="params.fileList"
            :auto-upload="params.autoUpload"
            :headers = "this.$utils.uploadAction().headers"
            >
            <div v-if="!params.multiple">
                <img  v-if="params.value && params.value != '--'"  :src="params.value" class="avatar" />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div v-if="params.isClose && params.value" class="close-wrap" @click.stop = "params.closeFun(params)">
                <i class="el-icon-circle-close"></i>
                </div>
                
            </div>
            <div v-else>
                <i  class="el-icon-plus avatar-uploader-icon"></i>
            </div>
            </el-upload>
            <div v-if="params.multiple">
                <div class="divImgWrap">
                    <div v-if="item" class="itemImg" v-for="(item) in params.value">
                        <img  :src="item" alt="暂无图片" class="avatar" />
                        <div v-if="item" class="close-wrap" @click.stop = "params.closeFun(item)">
                        <i class="el-icon-circle-close"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else-if="params.typeValue == 'file'">
            <el-upload
            class="upload-demo"
            name="file"
            :action="this.$utils.uploadAction(params.fileParams).action"
            :on-preview="params.handlePreview"
            :on-remove="params.handleRemove"
            :on-success="params.handleSuccess"
            :before-upload="params.beforeAvatarUpload"
            :on-error="params.handleError"
            :before-remove="params.beforeRemove"
            :multiple="params.multiple"
            :on-exceed="params.handleExceed"
            :disabled="params.disabled"
            :limit="params.limit"
            :file-list="params.fileList"
            :on-change="params.onChange"
            :headers = "this.$utils.uploadAction().headers"
            :auto-upload="params.autoUpload">
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            <!-- accept="image/png, image/jpeg" -->
            </el-upload>
        </div>
        <!-- 文件上传  不限制格式  可以多选      如果是图片就显示图片，是其他格式文件，就显示文件，并显示下载按钮 -->
        <div v-else-if="params.typeValue == 'fileArbitrarily'">
            <el-upload
            class="upload-demo"
            name="file"
            ref="fileArbitrarily"
            :action="this.$utils.uploadAction(params.fileParams).action"
            :on-preview="params.handlePreview"
            :on-remove="params.handleRemove"
            :on-success="params.handleSuccess"
            :before-upload="params.beforeAvatarUpload"
            :on-error="params.handleError"
            :before-remove="params.beforeRemove"
            :multiple="params.multiple"
            :on-exceed="params.handleExceed"
            :disabled="params.disabled"
            :limit="params.limit"
            :file-list="params.fileList"
            :on-change="params.onChange"
            :show-file-list="false"
            :headers = "this.$utils.uploadAction().headers"
            :auto-upload="params.autoUpload">
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            <!-- accept="image/png, image/jpeg" -->
            </el-upload>
            <div class="fileArbitrarilyWrap">
                <div class="disFlex">
                    <div  v-if="item.type == 'png' || item.type == 'jpg'" class="marR10 res" v-for="(item,index) in this.splitFile(params.value)" :key="index">
                        <img :src="item.url" class="avatar">
                        <div  class="close-wrap" @click.stop = "params.closeFun(item)">
                            <i class="el-icon-circle-close"></i>
                            <el-button class="marR10" type="primary" plain size="mini" @click.stop="downloadFile(item.url)">下载</el-button>
                        </div>
                    </div>
                </div>
                <div class="">
                    <div  v-if="item.type != 'png' && item.type != 'jpg'" class="marR10 res" v-for="(item,index) in this.splitFile(params.value)" :key="index">
                        <div class="disFlex">
                            <span class="marR10">{{ item.name }}</span>
                            <el-button class="marR10" type="primary" plain size="mini" @click.stop="downloadFile(item.url)">下载</el-button>
                            <span   class="close-wrap-f"  @click.stop = "params.closeFun(item)">
                                <i class="el-icon-circle-close"></i>
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 文件上传  不限制格式  可以多选  无删除按钮     如果是图片就显示图片，是其他格式文件，就显示文件  -->
        <div v-else-if="params.typeValue == 'fileArbitrarily_close'">
            <el-upload
            class="upload-demo"
            name="file"
            ref="fileArbitrarily"
            :action="this.$utils.uploadAction(params.fileParams).action"
            :on-preview="params.handlePreview"
            :on-remove="params.handleRemove"
            :on-success="params.handleSuccess"
            :before-upload="params.beforeAvatarUpload"
            :on-error="params.handleError"
            :before-remove="params.beforeRemove"
            :multiple="params.multiple"
            :on-exceed="params.handleExceed"
            :disabled="params.disabled"
            :limit="params.limit"
            :file-list="params.fileList"
            :on-change="params.onChange"
            :show-file-list="false"
            :headers = "this.$utils.uploadAction().headers"
            :auto-upload="params.autoUpload">
            <el-button size="small" type="primary">点击上传</el-button>
            <!-- <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div> -->
            <!-- accept="image/png, image/jpeg" -->
            </el-upload>
            <div class="fileArbitrarilyWrap">
                <div class="disFlex">
                    <div  v-if="item.type == 'png' || item.type == 'jpg'" class="marR10 res" v-for="(item,index) in this.splitFile(params.value)" :key="index">
                        <!-- <img :src="item.url" class="avatar"> -->
                        <el-image 
                            style="width: 100px; height: 100px"
                            :src="item.url" 
                            :preview-src-list="[item.url]">
                        </el-image>
                        <div  class="close-wrap" @click.stop = "params.closeFun(item)">
                            <!-- <i class="el-icon-circle-close"></i> -->
                            <el-button class="marR10" :disabled="false" type="primary" plain size="mini" @click.stop="downloadFile(item.url)">下载</el-button>
                        </div>
                    </div>
                </div>
                <div class="">
                    <div  v-if="item.type != 'png' && item.type != 'jpg'" class="marR10 res" v-for="(item,index) in this.splitFile(params.value)" :key="index">
                        <div class="disFlex">
                            <span class="marR10">{{ item.name }}</span>
                            <el-button class="marR10" :disabled="false" type="primary" plain size="mini" @click.stop="downloadFile(item.url)">下载</el-button>
                            <!-- <span   class="close-wrap-f"  @click.stop = "params.closeFun(item)">
                                <i class="el-icon-circle-close"></i>
                            </span> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 添加公司  额外参数 -->
        <div v-else-if="params.typeValue == 'fileGs'">
            <el-upload
            name="file"
            class="avatar-uploader"
            :action="this.$utils.uploadAction().action"
            :show-file-list="false"
            :on-success="params.handleSuccess"
            :before-upload="params.beforeAvatarUpload"
            :auto-upload="true"
            :headers = "this.$utils.uploadAction().headers"
            >
                <img v-if="params.value" :src="params.value" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <div v-if="params.value" class="close-wrap" @click.stop = "params.closeFun">
                  <i class="el-icon-circle-close"></i>
                </div>
          </el-upload>
        </div>
    </div>
</template>
<script>
    class Person { }
    import VDistpicker from 'v-distpicker';
    // import EditorCon from '@/components/editor/index.vue'
    import EditorCon from '@/components/editor/MyEditor.vue'
    import EditorTitleCon from '@/components/editor/MyEditorTitle.vue'
    export default {
        components: {
            VDistpicker,EditorCon,EditorTitleCon
        },
        props: {
            params: {
                type: Object,
                default: function(){
                    return {}
                }
            },
            ruleForm:{
                type: Object,
                default: function(){
                    return {}
                }
            }
        },
        data() {
            return {
            }
        },
        created () {
            this.person = new Person();
            console.log("11111111111111111111111111")
        },
        destroyed () {
            this.$off();
            this.person = null;
        },
        methods: {
            test(){
                console.log("1111111111")
            },
            //附件下载
            downloadFile(url){
            let that = this;
            
            if(!url || url == '--'){
                return that.$utils.msg('暂无下载链接',"error")
            }
                const link = document.createElement("a");
                link.href = url ;
                link.download =that.reverseName(url) || "";
                link.target = "_blank"
                link.click();
            },
            reverseName(str,format){
                if(!str) return;
                let fileName = "";
                let reverseStr = str.split("").reverse().join("");
                let strSplit = reverseStr.split(format)[0];
                fileName = strSplit.split("").reverse().join("");
                return fileName;
            },
            splitFile(fileStr){
                let that = this;
                let fileList = [];
                if(!fileStr) return fileList;
                fileList = fileStr.split(",");
                fileList = fileList.map((item)=>{
                    return {
                        name: that.reverseName(item,"/") || "",
                        url:item || "",
                        type:that.reverseName(item,".") || "",
                    }
                })
                return fileList;
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            }
        },
    }
</script>

<style lang="scss" scoped>
   /deep/ .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    // overflow: hidden;
  }
  .selectNoTags{
    /deep/ .el-select{
        width: 100% !important;
    }
  }
  /deep/ .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  /deep/.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  /deep/.avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
  .fileArbitrarilyWrap{
    margin-top: 10px;
    .disFlex{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .marR10{margin-right: 10px;}
    .res{
        position: relative;
    }
    .close-wrap-f{
        cursor: pointer;
        width:25px;
        height:25px;
        background:#fff;
        border-radius:50%;
        z-index:999;
        /deep/ .el-icon-circle-close{
        font-size:24px !important;
        }
    }
  }
  .btnUrlClass{
    .disFlex{
        display: flex;
        align-items: center;
        flex-wrap: wrap;
    }
    .marR10{margin-right: 10px;}
    .res{
        position: relative;
    }
    .close-wrap-f{
        cursor: pointer;
        width:25px;
        height:25px;
        background:#fff;
        border-radius:50%;
        z-index:999;
        /deep/ .el-icon-circle-close{
        font-size:24px !important;
        }
    }
  }
   .divImgWrap{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .itemImg{
        position: relative;
        margin: 5px 50px 5px 0px;
    }
   }
   .close-wrap{
      position: absolute;
      cursor: pointer;
      top: -10px;
      right: -10px;
      width:25px;
      height:25px;
      background:#fff;
      border-radius:50%;
      display:flex;
      z-index:999;
    /deep/ .el-icon-circle-close{
      font-size:24px !important;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/inputRule/index.vue